export default function Footer() {
  return (
    <footer className="bg-secondary-900 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-2">BB COFFEE</h3>
            <p className="text-xs tracking-widest uppercase text-background-400 mb-4">BeanhoodBrew</p>
            <p className="text-sm text-background-300 leading-relaxed">
              Your favourite neighbourhood coffee truck, serving freshly roasted handcrafted drinks since 2023. Freshness in Every Sip.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wider uppercase">Explore</h4>
            <ul className="space-y-2.5">
              {[
                { href: "#about", label: "About Us" },
                { href: "#menu", label: "Our Menu" },
                { href: "#event", label: "Event Catering" },
                { href: "#promotion", label: "Loyalty Card" },
                { href: "#experience", label: "Why Choose Us" },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wider uppercase">Contact</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-xs text-primary-400" />
                </div>
                <span className="text-sm text-background-400">Pusat Perniagaan Bukit Raja, Jalan Keluli AP7/AP, Seksyen 7, 40000 Shah Alam, Selangor (Infront of HARRAZ boutique)</span>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-xs text-primary-400" />
                </div>
                <a href="tel:+60133316383" className="text-sm text-background-400 hover:text-primary-300 transition-colors">013-3316383</a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-xs text-primary-400" />
                </div>
                <a href="mailto:bhbcoffee26@gmail.com" className="text-sm text-background-400 hover:text-primary-300 transition-colors">bhbcoffee26@gmail.com</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wider uppercase">Hours</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line text-xs text-primary-400" />
                </div>
                Mon - Sat
              </li>
              <li className="pl-6">10:00 AM - 9:00 PM</li>
              <li className="flex items-center gap-2 pt-1">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-close-line text-xs text-red-400" />
                </div>
                <span className="text-background-500 font-medium text-xs">Sun: Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500 text-center sm:text-left">
            &copy; 2026 BB COFFEE (BeanhoodBrew). All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            {[
              { icon: "ri-instagram-line", label: "Instagram" },
              { icon: "ri-facebook-line", label: "Facebook" },
              { icon: "ri-tiktok-line", label: "TikTok" },
              { icon: "ri-whatsapp-line", label: "WhatsApp" },
            ].map((social) => (
              <a
                key={social.label}
                href="#"
                aria-label={social.label}
                rel="noopener noreferrer"
                className="w-10 h-10 bg-background-50/10 hover:bg-primary-500 rounded-full flex items-center justify-center text-background-400 hover:text-background-50 transition-all duration-300"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${social.icon} text-lg`} />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}